// extracted by mini-css-extract-plugin
export default {"topMenu":"Dashboard_topMenu__UDooT","bodyContainer":"Dashboard_bodyContainer__EUqAK"};